import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import DropdownOption from "../Components/DropdownOption";
import { ReactComponent as IconSearch } from "../Images/icon_search.svg";

import { useLocation, useNavigate } from "react-router-dom";
import ApplyBtn from "../Components/ApplyBtn";
import MoreBtn from "../Components/MoreBtn";
import Layout from "../Layout/Layout";
import Pagination from "../Layout/Pagination";
import AlarmApply from "../Modals/AlarmApply";
import "../Styles/component.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils";
import { showToast } from "../Utils/variables";

const LEGACY_RESERVE_TIME_MAP = {
  1: { reserveHour: 20, reserveMinute: 0 },
  2: { reserveHour: 12, reserveMinute: 50 },
};

const parseReserveValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const parsedValue = Number(value);
  return Number.isNaN(parsedValue) ? null : parsedValue;
};

const formatReserveTime = (reserveHour, reserveMinute, timeType) => {
  const parsedHour = parseReserveValue(reserveHour);
  const parsedMinute = parseReserveValue(reserveMinute);

  if (parsedHour !== null && parsedMinute !== null) {
    return `${String(parsedHour).padStart(2, "0")}:${String(
      parsedMinute
    ).padStart(2, "0")}`;
  }

  const legacyReserveTime = LEGACY_RESERVE_TIME_MAP[timeType];

  if (!legacyReserveTime) {
    return "";
  }

  return `${String(legacyReserveTime.reserveHour).padStart(2, "0")}:${String(
    legacyReserveTime.reserveMinute
  ).padStart(2, "0")}`;
};

const PushManageContent = () => {
  const [total_push, setTotal_push] = useState(0);
  const [push_list, setPush_list] = useState([]);
  const location = useLocation();

  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const offset = 10;

  const getPushList = async () => {
    try {
      const body = {
        page,
        offset,
        searchTitle,
      };
      if (nowOrLater === "즉시발송") body.isReserve = 0;
      else if (nowOrLater === "예약발송") body.isReserve = 1;
      if (nation === "국내") body.cCode = "kr";
      else if (nation === "해외") body.cCode = "99";
      else if (nation === "전체") body.cCode = "00";
      const res = await postJson("/dashboard/push/getList", body, navigate);

      if (res.code === 200) {
        setPush_list(res.data.rows);
        setTotal_push(res.data.count);
      }
    } catch (error) {
      console.error("푸시 리스트 가져오기 중 에러:", error);
    }
  };

  const deletePush = async () => {
    try {
      const res = await postJson(
        "/dashboard/push/delete",
        { pushHistoryId },
        navigate
      );

      if (res.code === 200) {
        setAlarmState({ show: false, type: "" });
        window.location.reload();
      }
    } catch (error) {
      console.error("푸시 삭제 중 에러:", error);
    }
  };

  const [pushHistoryId, setPushHistoryId] = useState("");
  const [searchTitle, setSearchTitle] = useState("");
  const [nowOrLater, setNowOrLater] = useState("");
  const [alarmType, setAlarmType] = useState("홈");
  const [nation, setNation] = useState("");
  const [clickInput, setClickInput] = useState(false);
  const [alarmState, setAlarmState] = useState({ show: false, type: "" });
  const lastPushRequestKey = useRef(null);

  const nowOrLaterOption = (selectedOption) => {
    setNowOrLater(selectedOption);
  };

  const alarmTypeOption = (selectedOption) => {
    setAlarmType(selectedOption);
  };

  const nationOption = (selectedOption) => {
    setNation(selectedOption);
  };

  useEffect(() => {
    const requestKey = JSON.stringify({ nowOrLater, nation, page });

    if (lastPushRequestKey.current === requestKey) {
      return;
    }

    lastPushRequestKey.current = requestKey;
    getPushList();
  }, [nowOrLater, nation, page]);

  useEffect(() => {
    if (location.state?.toast_enable) {
      showToast("푸시알림이 등록되었습니다.", "success");
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);
  return (
    <div>
      {alarmState.show && (
        <AlarmApply
          title="항목을 삭제하시겠습니까?"
          subtitle={
            <>
              삭제하면 앱과 대시보드 내에서 해당
              <br />
              데이터가 영구적으로 사라집니다.
            </>
          }
          handleClickX={() => setAlarmState({ show: false, type: "" })}
          handleApply={deletePush}
        />
      )}
      {/* 푸시알림 관리 박스 */}
      <PushBox>
        <div className="title-in-box">푸시알림 관리</div>
        {/* 검색창 | 드롭다운 옵션 3개 | 등록하기 버튼 */}
        <div className="hrz-wrapper" style={{ marginTop: "20px" }}>
          {/* 검색창 */}
          <div
            className="searchBox"
            style={{ boxShadow: clickInput ? "inset 0 0 0 1px #1167ed" : "" }}
          >
            <input
              type="text"
              placeholder="푸시 내용"
              onChange={(e) => setSearchTitle(e.target.value)}
              onClick={() => setClickInput(true)}
              onBlur={() => setClickInput(false)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  getPushList();
                }
              }}
            />
            <IconSearch style={{ cursor: "pointer" }} />
          </div>

          {/* 드롭다운 옵션 */}
          <div style={{ display: "flex", marginLeft: "auto" }}>
            <DropdownOption
              title="발송 옵션"
              dropdown_list={["즉시발송", "예약발송"]}
              optionChange={nowOrLaterOption}
            />
            <DropdownOption
              title="푸시 국가"
              dropdown_list={["전체", "국내", "해외"]}
              optionChange={nationOption}
            />

            {/* 등록하기 버튼 */}
            <ApplyBtn addr="/push/apply" />
          </div>
        </div>

        {/* 전체 푸시알림 건수 */}
        <div
          className="hrz-wrapper"
          style={{ marginTop: "30px", color: "#000000" }}
        >
          전체 {total_push}건
        </div>

        {/* 푸시알림 리스트 */}
        <div className="listArea" style={{ marginTop: "10px" }}>
          {/* 라벨 */}
          <div
            className="list_titleBar"
            style={{
              gridTemplateColumns:
                "100px 340px 120px 120px 120px 220px 180px 120px ",
            }}
          >
            <p className="center">NO</p>
            <p className="leftalign">푸시 내용</p>
            <p className="leftalign">발송 옵션</p>
            <p className="leftalign">시간</p>
            <p className="leftalign">요일</p>
            <p className="leftalign">푸시 기간</p>
            <p className="leftalign">등록일</p>
            <p className="leftalign">푸시 국가</p>
          </div>

          {/* 데이터 */}
          {push_list.slice(0, 10).map((data) => (
            <PushData
              key={data.rownum}
              pushHistoryId={data.pushHistoryId}
              rownum={data.rownum}
              content={data.content}
              isReserve={data.isReserve}
              timeType={data.timeType}
              reserveHour={data.reserveHour}
              reserveMinute={data.reserveMinute}
              weekType={data.weekType}
              startTime={data.startTime}
              endTime={data.endTime}
              regTime={data.regTime}
              cCode={data.cCode}
              clickDelete={(id) => {
                setAlarmState({ show: true, type: "delete" });
                setPushHistoryId(id);
              }}
            />
          ))}
        </div>

        {/* 페이징 */}
        <Pagination
          totalPages={total_push === 0 ? 1 : Math.ceil(total_push / 10)}
          currentPage={page}
          onPageChange={(pageNum) => setPage(pageNum)}
        />
      </PushBox>
    </div>
  );
};

const PushData = ({
  pushHistoryId,
  rownum,
  isReserve,
  timeType,
  reserveHour,
  reserveMinute,
  weekType,
  startTime,
  endTime,
  regTime,
  cCode,
  content,
  clickDelete,
}) => {
  const daysOfWeek = ["월", "화", "수", "목", "금", "토", "일"];

  return (
    <div
      className="list_contentBar"
      style={{
        gridTemplateColumns:
          "100px 340px 120px 120px 120px 220px 180px 252px 52px",
      }}
    >
      <p className="center">{rownum}</p>
      <div className="scrollName leftalign">
        <p style={{ whiteSpace: "nowrap" }}>{content}</p>
      </div>
      <p className="leftalign">{isReserve === 0 ? "즉시발송" : "예약발송"}</p>
      {isReserve === 0 ? (
        <p></p>
      ) : (
        <p className="leftalign">
          {formatReserveTime(reserveHour, reserveMinute, timeType)}
        </p>
      )}
      {isReserve === 0 ? (
        <p> </p>
      ) : (
        <p className="leftalign">
          {weekType
            .split(",")
            .map((day) => daysOfWeek[day - 1])
            .join(", ")}
        </p>
      )}
      <p className="leftalign">
        {startTime} ~ {endTime}
      </p>
      <p className="leftalign">{regTime}</p>
      <p className="leftalign">
        {cCode === "kr" ? "국내" : cCode === "00" ? "전체" : "해외"}
      </p>

      <div className="center">
        <MoreBtn
          option1="수정"
          option2="삭제"
          option1Addr={`/push/edit/${pushHistoryId}`}
          optionClickDelete={() => clickDelete(pushHistoryId)}
        />
      </div>
    </div>
  );
};

const PushBox = styled.div`
  width: 1500px;
  height: auto;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 20px;
  margin-left: 30px;
  margin-top: 30px;
`;

const PushManage = () => {
  return <Layout page={<PushManageContent />} />;
};

export default PushManage;
